import SearchSelect from "ui-components/SearchSelect";
import { useState, useEffect } from "react";
import { LostWorkflowProps } from "./types";
import { useIntl } from "react-intl";
import {
  LostWorksiteSchema,
  LostWorksiteReasonSchema,
  BrandSchema,
} from "../types";
import GetData from "./data";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import {MandatoryLabel} from "../../MandatoryLabel";
import Input from "../../../../../ui-components/Input";

export const LostWorkflow = ({
  internalUser,
  setLostWorksiteData,
}: LostWorkflowProps) => {
  const intl = useIntl();
  const { brandChannelOptions, brandReasonOptions } = GetData(
    intl.formatMessage
  );
    const countryApiRequest = useCountryAxiosInstance();

  const [brandNameOptions, setBrandNameOptions] = useState<{ value: number; label: string }[]>([]);

  const [lostReason, setLostReason] = useState<{
    value: LostWorksiteReasonSchema;
    label: string;
  }>();

  const [brandName, setBrandName] = useState<{ value: number; label: string }>();
  const [brandReason, setBrandReason] = useState<{
    value: string;
    label: string;
  }>();

  const [whichSolutionNotFound, setWhichSolutionNotFound] = useState<string>("");

  useEffect(() => {
    let data = {
      type: "lost",
      reason: {
        type: lostReason?.value,
        ...(lostReason?.value === "OtherBrand" ? {brand: {
          name: brandName?.label,
          reason: brandReason?.value || "not_specified",
        } as BrandSchema}:{}),
        ...(lostReason?.value === "KKSolutionsOrProductsNotFound" ? {which_solution_not_found: whichSolutionNotFound}:{})
      },
    };

    if (lostReason?.value !== "OtherBrand" || !brandName?.value) {
      delete data.reason.brand;
    }
    if (lostReason?.value !== "KKSolutionsOrProductsNotFound" || !whichSolutionNotFound) {
      delete data.reason.which_solution_not_found;
    }
    setLostWorksiteData(data as LostWorksiteSchema);
  }, [lostReason, brandName, brandReason, whichSolutionNotFound]);

  useEffect(() => {
    async function fetchBrands() {
      // brandNameOptions
      let result = await countryApiRequest.get("/competitors/all");
      result.push(result.splice(result.find(el=>el.name==='other_brand'), 1)[0]);
      const brandOptions = result.map((el) => ({
        value: el.id,
        label: intl.formatMessage({id:el.name}),
      }));

      setBrandNameOptions(brandOptions);
    }
    fetchBrands();
  }, []);

  return (
    <>
      <SearchSelect
        label={<MandatoryLabel
          label={intl.formatMessage({
            id: "terminate_reason_lost_channel_label",
            defaultMessage: "Motivazione",
          })}
          mandatory={!lostReason}
        />}
        options={brandChannelOptions}
        value={brandChannelOptions.find((option) => option.value === lostReason?.value)}
        onChange={(e) => setLostReason(e)}
        isClearable
      />
      {lostReason?.value === "OtherBrand" && (
        <div>
          <SearchSelect
            label={<MandatoryLabel
              label={intl.formatMessage({
              id: "terminate_reason_lost_brand_label",
              defaultMessage: "Brand utilizzato",
              })}
              mandatory={!brandName && internalUser}
            />}
            options={brandNameOptions}
            value={brandNameOptions.find((option) => option.value === brandName?.value)}
            onChange={(e) => setBrandName(e)}
            isClearable
          />
          {brandName && (
            <SearchSelect
              label={
                <MandatoryLabel
                  label={intl.formatMessage({
                    id: "terminate_reason_lost_other_brand_reason",
                    defaultMessage: "Perché?",
                  })}
                  mandatory={false}
                />}
              options={brandReasonOptions}
              isClearable
              value={brandReasonOptions.find((option) => option.value === brandReason?.value)}
              onChange={(e) => setBrandReason(e)}
            />
          )}
        </div>
      )}
      {
        // input to specify which solution was not found.
        lostReason?.value === "KKSolutionsOrProductsNotFound" && (
          <Input
            label={<MandatoryLabel
              label={intl.formatMessage({
                id: "terminate_reason_lost_which_solution_not_found",
                defaultMessage: "Quale prodotto o soluzione non è presente?",
              })}
              mandatory={!whichSolutionNotFound}
            />}
            value={whichSolutionNotFound}
            onChange={(e: any) => setWhichSolutionNotFound(e.target.value)}
            required={true} translations={undefined} name={undefined} validation={undefined}
            errorMessage={undefined} showCalendar={undefined} checkTranslation={undefined}/>
        )
      }
    </>
  );
};
